React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_join_request_component')

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = {
      isProcessing: false
    }

  onClick: =>
    @setState(isProcessing: true)
    @props.onClick()

  render: t.renderable ->
    if @state.isProcessing
      t.div '.spinner.loading'
    else
      switch @props.acceptOrDecline
        when 'accept' then @_renderAccept()
        when 'decline'   then @_renderDecline()

  _renderDecline: ->
    t.div =>
      t.format 'decline-text'
      t.button '.primary.full', onClick: @onClick, ->
        t.format 'decline-button'

  _renderAccept: ->
    { newBillableMembersCount, currentTotal, max } = @props

    onClick = @onClick

    noMax = if max?
        ""
      else
        '-no-max'

    max ?= ""

    t.div ->
      if max? && currentTotal?
        switch newBillableMembersCount
          when 0
            t.format "confirm-add-to-enterprise-0#{ noMax }", { currentTotal, max }
          when 1
            t.format "confirm-add-to-enterprise-1#{ noMax }", { max, totalAfterNew: currentTotal + 1 }
          else
            t.format "confirm-add-to-enterprise-many#{ noMax }", { newBillableMembersCount, max, totalAfterNew: currentTotal + newBillableMembersCount }

      t.button '.primary.full', onClick: onClick, ->
        t.format 'confirm-button'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/handle-pending-organization-component.coffee